
const portfolioData = [
    {
        id:1,
        img:'assets/img/portfolio/port-1.jpg',
        title:'New Landing Screen',
        subtitle:'UI Design',
        category:'consulting',
    },
    {
        id:2,
        img:'assets/img/portfolio/port-2.jpg',
        title:'Dinamica Lifestyle',
        subtitle:'UI Design',
        category:'facilitation',
    },
    {
        id:3,
        img:'assets/img/portfolio/port-3.jpg',
        title: 'A Classic Cup',
        subtitle:'Photography',
        category: 'consulting',
    },
    {
        id:4,
        img:'assets/img/portfolio/port-4.jpg',
        title: 'Full Branding Crew',
        subtitle:'Photography',
        category: 'strategy',
    },
    {
        id:5,
        img:'assets/img/portfolio/port-5.jpg',
        title: 'New Landing Screen',
        subtitle:'UI UX Design',
        category:'strategy',
    },
    {
        id:6,
        img:'assets/img/portfolio/port-6.jpg',
        title: 'Landing Animation',
        subtitle:'UI UX Design',
        category:'strategy',
    },
    {
        id:7,
        img:'assets/img/portfolio/port-7.jpg',
        title: 'Branding New Clock',
        subtitle:'Photography',
        category: 'facilitation',
    },
    {
        id:8,
        img:'assets/img/portfolio/port-8.jpg',
        title: 'Diseno de Moda',
        subtitle:'UI Design',
        category:'facilitation',
    },
    {
        id: 9,
        img: 'assets/img/portfolio/port-1.jpg',
        title: 'New Landing Screen',
        subtitle: 'UI Design',
        category: 'strategy',
    },
    {
        id: 10,
        img: 'assets/img/portfolio/port-3.jpg',
        title: 'A Classic Cup',
        subtitle: 'Photography',
        category: 'design',
    },
    {
        id: 11,
        img: 'assets/img/portfolio/port-5.jpg',
        title: 'New Landing Screen',
        subtitle: 'UI UX Design',
        category: 'design',
    },
    {
        id: 12,
        img: 'assets/img/portfolio/port-7.jpg',
        title: 'Branding New Clock',
        subtitle: 'Photography',
        category: 'design',
    },
]

export default portfolioData;